/**
 * 系统管理  课程表模板管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>课程表模板管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.mbmc" placeholder="输入模板名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-form-item label="选择科目" prop="subjectId">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="queryParams.subjectId"
            :options="treeOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="mbmc" label="模版名称">
      </el-table-column>
      <el-table-column prop="subjectName" label="科目">
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="50%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="模板名称" prop="mbmc">
          <el-input size="small" v-model="form.mbmc" placeholder="请输入" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="培训科目" prop="subjectId">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="form.subjectId"
            :options="treeOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            @change="handleSubChange"
            clearable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="选择课程">
          <el-button type="primary" @click="handleOpenCourse()">打开课程</el-button>
        </el-form-item>

        <el-table
          size="small"
          :data="courseList"
          highlight-current-row
          v-loading="loading"
          border
          element-loading-text="拼命加载中"
          style="width: 99%; margin: 0 auto;"
        >
          <el-table-column label="序号" align="center" type="index" width="60"/>
          <el-table-column prop="kcmc" label="课程名称"/>
          <el-table-column prop="xs" label="学时"/>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
              >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="deleteCourse(scope.$index, scope.row)"
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择课程" :visible.sync="openCourse" width="70%" :close-on-click-modal="false" @click="openCourse = false">
      <CourseManage :flag="2" :key="add_index" :subjectId="form.subjectId" :toList="courseList" v-on:courseListData="courseListData"></CourseManage>
    </el-dialog>

  </div>
</template>

<script>
import {getCourseMbList, addCourseMb, editCourseMb, deleteCourseMbById, queryCourseMbById} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import CourseManage from '../course/courseManage.vue'
import {formatInportData, timestampToTime} from "../../utils/util";
import {selectAreaTree} from "../../api/subjectTree";

export default {
  data() {
    return {
      add_index: 0,
      // 教室信息
      openCourse: false,
      courseList: [],

      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        mbmc: [
          { required: true, message: '请输入模版名称', trigger: 'blur' }
        ],
        subjectId: [
          { required: true, message: '请选择培训科目', trigger: 'blur' }
        ],
      },
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      treeOptions: undefined,

    }
  },
  // 注册组件
  components: {
    Pagination,
    CourseManage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata();
      this.selectAreaTree();
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
        }
      })
    },
    // 获取营销渠道列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getCourseMbList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },

    handleSubChange(value) {
      console.log(value)
    },
    handleOpenCourse() {
      if (!this.form.subjectId) {
        this.$message.error('请先选择培训科目');
        return;
      }
      this.openCourse = true;
      this.add_index++;
    },

    courseListData(item) {
      this.courseList = item;

      this.openCourse = false;
    },

    deleteCourse(index, item) {
      this.courseList.splice(index, 1);
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        queryCourseMbById(row.id).then(res => {
          if (res.code == 200) {
            this.form = res.data;

            if (this.form.courseMbItemList.length > 0) {
              var list = [];
              this.form.courseMbItemList.forEach(x => {
                list.push({
                  id: x.courseId,
                  kcmc: x.kcmc,
                  xs: x.xs
                })
              })

              this.courseList = list;
            }
          }
        })
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {

          if (this.courseList.length == 0) {
            this.$message.error('请选择课程');
            return;
          }

          var list = [];
          this.courseList.forEach(x => {
            list.push({courseId: x.id})
          })
          var params = {
            mbmc: this.form.mbmc,
            subjectId: this.form.subjectId,
            courseMbItemList: list
          }

          if (this.form.id) {
            params.id = this.form.id;
            // 修改
            editCourseMb(JSON.stringify(params)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          } else {

            // 新增
            addCourseMb(JSON.stringify(params)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }


        } else {
          return false
        }
      })
    },
    // 删除
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteCourseMbById(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/templateManage.vue